// // ** React Imports
// import React from 'react'
//
//
// const SingleImagePicker = ({handleChange, handleUpload, progress, url, image}) => {
//     console.log(image, "image------")
//
//     return (
//         <div style={{padding: "20px"}}>
//             { progress !== 100 && <input type="file" onChange={handleChange}/>}
//             {/*<button onClick={handleUpload} disabled={!image}>*/}
//             {/*    Upload Image*/}
//             {/*</button>*/}
//             {progress > 0 && progress !== 100 && <p>Upload Progress: {progress.toFixed(2)}%</p>}
//             {url && (
//                 <div>
//                     {/*<p>Image URL:</p>*/}
//                     {/*<a href={url} target="_blank" rel="noopener noreferrer">{url}</a>*/}
//                     {/*<a href={url} target="_blank" rel="noopener noreferrer">{url}</a>*/}
//                     <img src={url} alt="Uploaded" width="200px" style={{marginTop: '10px'}}/>
//                 </div>
//             )}
//         </div>
//     )
// }
//
// export default SingleImagePicker

import { styled } from '@mui/material';
import React from 'react';
import { FiUploadCloud } from 'react-icons/fi';

const SingleImagePicker = ({ handleChange, handleUpload, progress, url, image, imagePreview }) => {
    return (
      <UploaderWrapper>
        <div className="file-upload-form">
          {!url && (
            <label className="file-upload-label">
              <div className="file-upload-design">
                <FiUploadCloud className="upload-icon" />
                <p className="title">Drag and Drop or</p>
                <span className="browse-button">Browse File</span>
                {imagePreview && (
                  <img src={imagePreview} alt="Preview" className="" />
                )}
              </div>
              <input type="file" onChange={handleChange} />
            </label>
          )}

          {/* {!url && (
            <button className="upload-btn" onClick={handleUpload}>
              Upload Image
            </button>
          )} */}

          {progress > 0 && !url && (
            <div className="progress-bar">
              <div className="progress" style={{ width: `${progress}%` }} />
              <p>{progress.toFixed(2)}%</p>
            </div>
          )}

          {url && (
            <div className="uploaded-image">
              <div>
                <a href={url} target="_blank" rel="noopener noreferrer">
                  View Uploaded Image
                </a>
              </div>
              <div>
                <img src={url} alt="Uploaded" />
              </div>
            </div>
          )}
        </div>
      </UploaderWrapper>
    );
};

const UploaderWrapper = styled("div")`
  .file-upload-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px;
    background-color: #f5f7fa;
    border-radius: 12px;
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
    margin: auto;
  }

  .file-upload-label input {
    display: none;
  }

  .upload-icon {
    font-size: 50px;
    color: #526484;
    margin-bottom: 15px;
  }

  .file-upload-label {
    cursor: pointer;
    padding: 25px;
    border: 2px dashed #526484;
    border-radius: 12px;
    text-align: center;
    transition: border-color 0.3s;
    width: 100%;
  }

  .file-upload-label:hover {
    border-color: #1e40af;
  }

  .title {
    font-size: 14px;
    margin-bottom: 10px;
    color: #526484;
  }

  .file-upload-design {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 250px; 
    position: relative;
  }

  .file-upload-design img {
    width: 250px; 
    height: 250px; 
    object-fit: contain;
    border-radius: 8px;
    border: 1px solid #ccc;
    background-color: #fff;
  }

  .browse-button {
    display: inline-block;
    background-color: #526484;
    color: #fff;
    padding: 6px 15px;
    border-radius: 8px;
    font-size: 13px;
    transition: background-color 0.3s;
  }

  .browse-button:hover {
    background-color: #1e40af;
  }

  .upload-btn {
    margin-top: 15px;
    padding: 8px 16px;
    background-color: #1e40af;
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .upload-btn:hover {
    background-color: #153277;
  }

  .progress-bar {
    width: 100%;
    background-color: #ddd;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 15px;
    position: relative;
  }

  .progress {
    height: 8px;
    background-color: #1e40af;
    transition: width 0.3s;
  }

  .progress-bar p {
    position: absolute;
    top: -22px;
    right: 0;
    font-size: 12px;
    color: #526484;
  }

  .uploaded-image {
    margin-top: 15px;
    text-align: center;
  }

  .uploaded-image img {
    margin-top: 10px;
    width: 100%;
    max-width: 200px;
    border-radius: 10px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  }

  .uploaded-image a {
    color: #1e40af;
    text-decoration: none;
    font-size: 14px;
  }

  .uploaded-image a:hover {
    text-decoration: underline;
  }
`;

export default SingleImagePicker;


